module.exports = __webpack_public_path__ + "static/media/cherry.6f19dc14.png";